import { get } from "../../utils/object-helpers";

$ {
    const EDIT_MAX_LENGTH = 1000;
    const EDIT_ROWS = 4;
    const descriptionText = get(state, "about.textSpans.0.text", "");
}

<div class="str-profile-edit-drawer" key="str-profile-edit-drawer">
    <str-title class="str-profile-edit-drawer__title" ...input.title />
    <div class="str-profile-edit-drawer__edit-wrap">
        <span class="str-profile-edit-drawer__edit-desc">
            <str-textual-display ...state.aboutEditDescription />
        </span>
        <textarea
            id="str-profile-edit-drawer__edit-textarea"
            aria-label=input.titleText
            placeholder=input.titleText
            value=descriptionText
            on-input("handleTextUpdate")
            disabled=state.profileEditState?.saving
            maxlength=EDIT_MAX_LENGTH
            rows=EDIT_ROWS/>
        <span class="str-profile-edit-drawer__char-count">
            ${descriptionText.length}/${EDIT_MAX_LENGTH}
        </span>
    </div>
    <div class="str-profile-edit-drawer__edit-buttons">
        <str-profile-edit-buttons
            mobileView="save-and-cancel"
            page=input.page
            globalState=input.globalState />
    </div>
</div>
